import React from 'react';

import { Fade } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { SnackbarProvider } from 'notistack';

import {
  Error as ErrorIcon,
  Info as InfoIcon,
  Success as SuccessIcon,
  Warning as WarningIcon,
} from '../../components/icons';

const useStyles = makeStyles((theme: Theme) => ({
  notificationRoot: {
    bottom: '10px',
  },
  notification: {
    // default: notice
    backgroundColor: theme.palette.common.black,
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.common.white,
    fontFamily: theme.typography.fontFamily,

    '& [class*="contentRoot"]': {
      boxShadow: 'none',
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSize,
      padding: theme.spacing(2),
    },

    '& .fd-icon svg': {
      marginRight: theme.spacing(1.5),
    },
  },
  error: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,

    '& .fd-icon svg': {
      color: theme.palette.error.contrastText,
    },
  },
  info: {
    backgroundColor: theme.palette.info.main,
    color: theme.palette.info.contrastText,

    '& .fd-icon svg': {
      color: theme.palette.info.contrastText,
    },
  },
  success: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,

    '& .fd-icon svg': {
      color: theme.palette.success.contrastText,
    },
  },
  warning: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,

    '& .fd-icon svg': {
      color: theme.palette.warning.contrastText,
    },
  },
}));

export function NotificationsProvider({ children }): JSX.Element {
  const classes = useStyles();

  const errorStyles = clsx(classes.notification, classes.error);
  const infoStyles = clsx(classes.notification, classes.info);
  const successStyles = clsx(classes.notification, classes.success);
  const warningStyles = clsx(classes.notification, classes.warning);

  return (
    <SnackbarProvider
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'bottom',
      }}
      autoHideDuration={5000}
      classes={{
        containerRoot: classes.notificationRoot,
        root: classes.notification,
        variantError: errorStyles,
        variantInfo: infoStyles,
        variantSuccess: successStyles,
        variantWarning: warningStyles,
      }}
      iconVariant={{
        error: <ErrorIcon />,
        info: <InfoIcon />,
        success: <SuccessIcon />,
        warning: <WarningIcon />,
      }}
      preventDuplicate
      TransitionComponent={Fade}
    >
      {children}
    </SnackbarProvider>
  );
}
